import { create } from 'zustand'
import { Shop, ShopProduct } from '../types'

interface MarketState {
  shops: Shop[]
  shopProducts: ShopProduct[]
  isLoading: boolean
  error: string | null
  
  // Actions
  setShops: (shops: Shop[]) => void
  setShopProducts: (products: ShopProduct[]) => void
  loadShops: () => Promise<void>
  loadShopProducts: (shopId: string) => Promise<void>
  sellProduct: (shopId: string, productId: string, quantity: number) => Promise<boolean>
  reset: () => void
}

export const useMarketStore = create<MarketState>((set) => ({
  shops: [],
  shopProducts: [],
  isLoading: false,
  error: null,
  
  setShops: (shops) => set({ shops, error: null }),
  setShopProducts: (shopProducts) => set({ shopProducts, error: null }),
  
  loadShops: async () => {
    set({ isLoading: true, error: null })
    
    try {
      const response = await fetch('https://business-tycoon-worker.smnshzh.workers.dev/api/market/shops')
      if (!response.ok) {
        throw new Error('Failed to load shops')
      }
      
      const shopsData: Shop[] = await response.json()
      set({ shops: shopsData, isLoading: false })
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'Unknown error',
        isLoading: false 
      })
    }
  },
  
  loadShopProducts: async (shopId: string) => {
    set({ isLoading: true, error: null })
    
    try {
      const response = await fetch(`https://business-tycoon-worker.smnshzh.workers.dev/api/market/shops/${shopId}/products`)
      if (!response.ok) {
        throw new Error('Failed to load shop products')
      }
      
      const productsData: ShopProduct[] = await response.json()
      set({ shopProducts: productsData, isLoading: false })
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'Unknown error',
        isLoading: false 
      })
    }
  },
  
  sellProduct: async (shopId: string, productId: string, quantity: number) => {
    try {
      const response = await fetch('https://business-tycoon-worker.smnshzh.workers.dev/api/market/sell', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          shopId,
          productId,
          quantity
        })
      })
      
      return response.ok
    } catch (error) {
      return false
    }
  },
  
  reset: () => set({ shops: [], shopProducts: [], error: null, isLoading: false })
}))
